module.exports = __webpack_public_path__ + "static/media/manovr-7.2d4f4a7f.jpg";